import React from 'react';
import { DataTable } from 'components/uiParts/DataGrid/DataTable';
import { Breadcrumb } from 'components/uiParts/Breadcrumb';
// 定数ファイル
import { CUSTOMER_CATEGORY_COLUMNS } from 'utils/constantsTable';

export const CustomerCategory1ListPage = () => {
  const breadcrumbList = [
    { name: 'ダッシュボード', href: '/' },
    { name: '得意先区分1一覧', href: '/customerCategory1/list' },
  ];

  return (
    <>
      <Breadcrumb breadcrumbList={breadcrumbList} />
      <DataTable
        title='得意先区分1一覧'
        columns={CUSTOMER_CATEGORY_COLUMNS}
        table='CustomerCategory1'
        api='CustomerCategory1'
        isCreateBtn
        isDetailBtn
        isDeleteBtn
        createUrl='/customerCategory1/create'
        detailUrl='/customerCategory1/detail'
        defaultFilterColumn='name'
        defaultFilterOperator='contains'
      />
    </>
  );
};
